module.exports = __webpack_public_path__ + "static/media/bg.b17fc0a9.png";